// extracted by mini-css-extract-plugin
export default {"time-input":"SLA_time-input__Ufi9X"};